import client from '../../base-api';

const serviceURL = '/unemployed/group-coaching';

const groupCoachingService = {
    getGroupCoachingList(unemployedId: number) {
        return client.get(`${serviceURL}/${unemployedId}`);
    },
    getGroupCoaching(id: number) {
        return client.get(`${serviceURL}/details/${id}`);
    },
    postGroupCoaching(coachingData: any) {
        return client.post(`${serviceURL}`, coachingData);
    },
    putGroupCoaching(coachingData: any, coachingId: number) {
        return client.put(`${serviceURL}/${coachingId}`, coachingData);
    },
    deleteGroupCoaching(coachingId: number) {
        return client.delete(`${serviceURL}/delete/${coachingId}`);
    },
}

export default groupCoachingService;